export default {
  improvementplans: {
    title: 'Rencana Peningkatan',
    high: 'Tinggi',
    middle: 'Sedang',
    low: 'Rendah',
    exceed: 'Terlalu besar',
    policy: 'Kebijakan',
    measure: 'Tindakan',
    result: 'Hasil',
    currently_supporting: 'Sedang Berlangsung',
    completion: 'Selesai',
    ended: 'Belum Selesai',
    risk: 'Risiko',
    thema: "@:{'common.esg.category'}",
    improvement_plan: 'Rencana Peningkatan',
    deadline_for_completion: 'Tenggat',
    message_count: 'Pesan',
    operation: 'Pengoperasian',
    detail: "@:{'common.scorecard.detail'}",
    indicator: 'Indikator',
    indicator_point: 'perbaikan',
    buyer_indicator_point: 'Komentar Penilaian',
    status: 'Status',
    supported: 'Selesai',
    unsupported: 'Tidak ada tindakan',
    progress: 'Status',
    advice: {
      text_line_1: 'Mari mulai tingkatkan kinerja ESG Anda dari penilaian ini.',
      // text_line_2: "",
      text_line_3: '"Buat Rencana Peningkatan" untuk menetapkan target waktu menyelesaikan',
      text_line_4: 'saran yang diterima.',
      text_line_5: 'Kemajuan dapat diperiksa pada grafik di sebelah kiri.',
      text_line_6: 'Jika Anda ingin meminta evaluasi ulang, silakan ',
      contact: 'Hubungi kami',
      please_contact_us: '.',
    },
    sub_section_title_1: 'Rencana perbaikan sedang berlangsung',
    no_data_display: 'Tidak ada data tersedia',
    // sub_section_title_2: "",
    buyer_sub_section_title_2: 'Komentar penilaian yang belum selesai',
    operation_link_text: 'Buat rencana perbaikan',
    // add_advice: "",
    // sub_section_title_3: "",
    buyer_sub_section_title_3: 'Komentar penilaian yang telah selesai',
    // revaluation_request: "",
    cautionary_note: 'Apakah Anda ingin meminta penilaian ulang berdasarkan rencana perbaikan yang telah Anda selesaikan?',
    asterisked_text: 'Jika Anda ingin meminta penilaian ulang, silakan lakukan melalui formulir kontak.',
    submit_btn_text: 'Minta penilaian ulang',
    table_state: 'tableState',
    select_a_file: 'Pilih File',
    attached_file: 'Lampirkan File',
    notes: 'Catatan',
    created_improvement_plan: 'Membuat Rencana Perbaikan',
    error_file_upload: 'Terjadi kesalahan pengunggahan file',
    failed_to_create: 'Gagal membuat rencana perbaikan. Coba segarkan halaman.',
    no_data_found: 'Tidak menemukan data untuk perbaikan.',
    file_upload: {
      filesize_max: 'Pilih file yang berukuran kurang dari 10 MB.',
      max_files: 'Anda dapat mengunggah hingga 10 file.',
      confirmation_of_deletion: 'Anda ingin menghapus file ini?',
    },
    // create_improvement_plan: "",
    no_data_improvement_plan: 'Saat ini belum ada rencana perbaikan.',
  },
  buyer_improvementplans: {
    flag: 'Tandai',
    memo: 'Memo',
    flag_on: 'Tetapkan tanda',
    flag_off: 'Hapus tanda',
    panel: {
      title: 'Informasi Perusahaan/Memo',
      company_memo: 'Memo perusahaan',
      latest_memo: 'Memo terbaru',
      no_memo: 'Belum ada memo.',
      check_list: 'Daftar periksa',
      memo_list: 'Daftar memo',
      // no_assignee: "",
      assignee_select_box: {
        // assignee: "",
        // placeholder: "",
        // create_member: "",
      },
      create_member_modal: {
        // title: "",
        // label: "",
        // place_holder: "",
      },
      delete_member_modal: {
        // title: "",
        // confirm_text: "",
        delete_button_label: "@:{'improvement_plans_detail.chat.delete_confirm.delete_button_label'}",
      },
    },
    back_to_list: 'Kembali ke Daftar',
    action_cases: 'Kasus',
    no_improvements: 'Tidak ada saran untuk perbaikan',
    confirm_delete_memo: 'Anda yakin ingin menghapus memo ini?',
    confirm_delete_memo_title: 'Hapus memo',
    // display_only_is_marked: "",
    create_memo: 'Buat memo',
  },
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
    },
  },
}
